import { ICellRendererParams } from "@ag-grid-community/core";
import { CustomCellEditorProps } from "@ag-grid-community/react";
import { HStack, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
import { SimpleTextInput } from "shared/components/input/text/SimpleTextInput";
import { useMaybernTableCellEditorProps } from "shared/components/table/maybern/MaybernTableCellEditor";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { ErrorIcon } from "shared/icons/ErrorIcon";

export interface MaybernTableTextCellEditorParams {
  placeholder?: string;
}

export const MaybernTableTextCellEditor: React.FC<
  CustomCellEditorProps & MaybernTableTextCellEditorParams
> = ({ placeholder, ...props }) => {
  const { inputRef, value, onValueChange, error } =
    useMaybernTableCellEditorProps(props);

  return (
    <SimpleTextInput
      ref={inputRef}
      variant="simple-table"
      placeholder={placeholder}
      value={value}
      onChangeValue={onValueChange}
      error={error}
    />
  );
};

export const MaybernTableTextCellEditorRenderer: React.FC<
  ICellRendererParams<string>
> = ({ value, column, node, context }) => {
  const isEditable = column?.isCellEditable(node);
  const error = getMaybernTableCellError({ column, node, context });
  const placeholder = (
    column?.getColDef().cellEditorParams as
      | MaybernTableTextCellEditorParams
      | undefined
  )?.placeholder;
  return (
    <HStack mx="1px" flexGrow={1} justifyContent="space-between">
      <Text
        textColor={value ? undefined : "gray.400"}
        opacity={isEditable ? 1 : 0.5}
      >
        {value || (isEditable ? placeholder : "")}
      </Text>
      {error && (
        <Tooltip openDelay={0} bg="red.600" color="white" label={error}>
          <ErrorIcon mr="-8px" />
        </Tooltip>
      )}
    </HStack>
  );
};
